import axios from "axios";
import { removeAdminAuth, removeAuth } from "../helpers/auth";
import { defaultConfig } from "../config";
import { ErrorMessage } from "../helpers/common";

const axiosInt = axios.create({
  baseURL: defaultConfig.baseAPIUrl,
});

axiosInt.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const isAdminRoute = window.location.pathname.startsWith("/admin");
    if (error?.response?.status === 401) {
      if (isAdminRoute){ 
        removeAdminAuth()
        window.location.href = `/admin/login`;

      }
      else {
        removeAuth()
        window.location.href = `/login`;
      }
    }
    if (error?.response?.status === 403) {
      window.location.href = "/";
    } else {
      ErrorMessage(error?.message);
    }
  }
);

export default axiosInt;
